import React from "react";
import { useApp } from "@/contexts/AppContext";
import SectionHeading from "@/components/SectionHeading";
import ScenarioCard from "@/components/ScenarioCard";

export default function ScenariosPage() {
  const { scenarios, t } = useApp();
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-10 py-16 sm:py-24">
      <SectionHeading
        label={t.sceneList.label}
        title={t.sceneList.title}
        subtitle={t.sceneList.subtitle}
      />
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {scenarios.map((sc) => (
          <ScenarioCard key={sc.slug} scenario={sc} />
        ))}
      </div>
    </section>
  );
}
